import React, { FC } from "react";
import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

interface SimpleAvailabilityModalProps {
  isOpen: boolean;
  onClose: () => void;
  locationTitle: string;
}

const SimpleAvailabilityModal: FC<SimpleAvailabilityModalProps> = ({ isOpen, onClose, locationTitle }) => {
  console.log("SimpleAvailabilityModal render - isOpen:", isOpen);

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/25" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="mx-auto max-w-sm rounded bg-white p-6">
          <div className="flex items-center justify-between mb-4">
            <Dialog.Title className="text-lg font-medium">Disponibilités - {locationTitle}</Dialog.Title>
            <button onClick={onClose} className="rounded-md p-1 hover:bg-gray-100">
              <XMarkIcon className="h-5 w-5" />
            </button>
          </div>

          <p className="text-gray-600 mb-4">Modal de test fonctionnel !</p>

          <div className="flex justify-end space-x-2">
            <button onClick={onClose} className="px-4 py-2 text-sm bg-gray-200 rounded hover:bg-gray-300">
              Fermer
            </button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};

export default SimpleAvailabilityModal;
